import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

const InfoContact = () => {
  const { t } = useTranslation()

  return (
    <>
      <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }}>
        <Typography variant="body1" flex={1} mb={1}>
          {t('contact.companyName')}
        </Typography>
      </Box>
      <Typography variant="body2" mb={1} fontSize="13px">
        {t('contact.addressDescription')}
        <br />
        {t('contact.cityandCountry')}
      </Typography>
      <Typography variant="body2" mb={1} fontSize="13px">
        {t('contact.phoneNumber')}
        <br />
        {t('contact.faxNumber')}
        <br />
        {t('contact.email')}
      </Typography>
      <Divider sx={{ width: '50%', mt: 4, mb: 4, bgcolor: 'grey.900' }} />
      <Typography variant="h6" mb={1}>
        {t('contact.businessHours')}
      </Typography> 
      <Typography variant="body2" mb={1} fontSize="13px">
        {t('contact.hours')}
      </Typography>
      <Typography variant="body2" mb={1} fontSize="13px">
        {t('contact.weekendHours')}
      </Typography>
      <Divider sx={{ width: '50%', mt: 4, mb: 4, bgcolor: 'grey.900' }} />
    </>
  )
}

export default InfoContact
